/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Ornate_Gaudy_Eel_ExhaleInputs */

const fr_ornate_gaudy_eel_exhale = /** @type {(inputs: Ornate_Gaudy_Eel_ExhaleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Assurez-vous que le nouvel email est valide et accessible.`)
};

/**

* @param {Ornate_Gaudy_Eel_ExhaleInputs} inputs
* @param {{ locale?: "fr" }} options
* @returns {LocalizedString}
*/
export const ornate_gaudy_eel_exhale = /** @type {((inputs?: Ornate_Gaudy_Eel_ExhaleInputs, options?: { locale?: "fr" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Ornate_Gaudy_Eel_ExhaleInputs, { locale?: "fr" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return fr_ornate_gaudy_eel_exhale(inputs)
});